import { QuestionComponentProps } from "..";

import { LanguageRequirementSelector } from "./components/LanguageRequirementSelector";

export const LanguageRequirement = ({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement => {
  return (
    <LanguageRequirementSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
};
